import apiFetch from '../apiFetch'

export default function (token, financingTypeProduct) {
  return apiFetch({ endPoint: 'FinancingTypeProduct/Insert/', method: 'POST', body: financingTypeProduct, token: token })
}
